import { veeqoErrors } from './errors/veeqo';
import { seCeErrors } from './errors/seCe';

export const errors = {
  seCe: seCeErrors,
  veeqo: veeqoErrors,
};

export type ErrorType = keyof ReturnType<typeof seCeErrors> & keyof ReturnType<typeof veeqoErrors>;
export type ContentType = keyof typeof errors;
